export default "__VITE_ASSET__0bPp2geA__"